import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import HeaderBox from './header-box'
import { getItemsCount } from 'modules/links/selectors'

const TotalPane = ({ total }) =>
  <HeaderBox header="Total pages" value={ <span className="h1">{ total }</span> } />

TotalPane.propTypes = {
  total: PropTypes.number.isRequired,
}

export default connect(
  createStructuredSelector({ total: getItemsCount }))(TotalPane)



// WEBPACK FOOTER //
// ./src/components/links/header/total-pages.js